import { render, staticRenderFns } from "./VendorUserRole.vue?vue&type=template&id=937ac2c4&scoped=true&"
import script from "./VendorUserRole.vue?vue&type=script&lang=js&"
export * from "./VendorUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937ac2c4",
  null
  
)

export default component.exports